import { useInstallPrompt } from '@/hooks/useInstallPrompt';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Download } from 'lucide-react';

// Shown on the customer portal so people can install THE TIFFIN as a home-screen app.
export function InstallAppButton({ className = '' }) {
  const { canInstall, installed, promptInstall } = useInstallPrompt();

  if (installed || !canInstall) return null;

  const install = async () => {
    const accepted = await promptInstall();
    if (accepted) toast.success('THE TIFFIN app installed!');
  };

  return (
    <Button
      variant="outline"
      data-testid="install-app-btn"
      onClick={install}
      className={`rounded-full border-saffron text-saffron hover:bg-saffron/10 transition-colors duration-150 ${className}`}
    >
      <Download size={15} className="mr-1.5" /> Install App
    </Button>
  );
}
